<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import NervenetFrame from './NervenetFrame.vue';

const props = defineProps({
  page: {
    type: String,
    default: 'orders',
  },
});

const { accountId } = useAccount();

// Only 'orders' (bills) is ever loaded from here — the sidebar has one entry
// for the whole module. Products is reached via the in-page subnav rendered
// inside Nervenet's own commerce layout, a normal link inside this already-
// loaded iframe, so it never needs a second sidebar route or a fresh token.
const PAGE_PATHS = {
  orders: 'commerce/orders',
};

const commerceUrl = computed(() => {
  const path = PAGE_PATHS[props.page] || PAGE_PATHS.orders;
  return `${window.chatwootConfig.nervenetBaseUrl}/accounts/${accountId.value}/${path}`;
});
</script>

<template>
  <div class="w-full h-full">
    <NervenetFrame :src="commerceUrl" />
  </div>
</template>
